<cass-core-toolbar></cass-core-toolbar>
<div class='page-container'>
	<mat-card class="branding--title-card">
		<mat-card-content>
			<h1>{{ "MY_ADS.PAGE.MAIN_TITLE" | translate }}
				<div class="section-card-button-container">
					<button mat-stroked-button (click)="createOrder()">
						{{ "MY_ADS.PAGE.ACTION_BUTTON_LABELS.NEW_ORDER" | translate }}</button>
					<!-- <app-customer-list-filter></app-customer-list-filter> -->
				</div>
			</h1>
		</mat-card-content>
	</mat-card>
	<cass-my-ads-list [displayMode]="displayMode" [showToolsPanel]="true"></cass-my-ads-list>
</div>
